import React from 'react';
import { Cpu, Award, Clock, Palette, Globe, Trophy } from 'lucide-react';
import { WHY_CHOOSE } from '../data/mock';
import SectionHeading from './SectionHeading';

const iconMap = { Cpu, Award, Clock, Palette, Globe, Trophy };

const WhyChoose = () => {
  return (
    <section className="section-pad bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          eyebrow="Why Us"
          title="Why India Chooses"
          accent="Mr. Coconetto"
          subtitle="Every detail — from the coconut we hand-pick to the CocoBoy who serves it — is engineered for wow moments."
        />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY_CHOOSE.map((w, i) => {
            const Icon = iconMap[w.icon] || Award;
            return (
              <div
                key={w.title}
                className="coco-card relative rounded-3xl bg-white border border-pink-100 shadow-soft p-6 overflow-hidden"
                style={{ animationDelay: `${i * 60}ms` }}
                data-testid={`why-card-${w.num}`}
              >
                <div className="absolute -top-2 -right-2 font-display font-black text-7xl text-pink-100/70 leading-none">{w.num}</div>
                <div className="relative">
                  <span className="w-12 h-12 rounded-2xl bg-blush text-pink-brand flex items-center justify-center">
                    <Icon className="w-5 h-5" />
                  </span>
                  <h3 className="mt-4 font-display font-semibold text-xl text-stone-900">{w.title}</h3>
                  <p className="mt-2 text-sm text-stone-600 leading-relaxed">{w.description}</p>
                  {w.tag && (
                    <span className="mt-4 inline-block text-[10px] font-bold uppercase tracking-widest text-pink-brand bg-blush rounded-full px-3 py-1">
                      {w.tag}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
